import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class Header extends Component {

	state = {
		cdm: false
	}
	componentDidMount() {
		setTimeout(() => {
			this.setState({ cdm: true})
		}, 2500)
	}

	handleHide = () => {
		setTimeout(() => {
			this.setState({ cdm: false})
		}, 250)
	}
	
	render() {
		const { children } = this.props
		return (
			<header>
				<Link to="/purchase" className={`top-left-tagline ${this.state.cdm && "active"}`} onClick={this.handleHide}>
					<u>2024</u> Preorder
				</Link>
				<div className="line"></div>
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Link to="/"><img
								className="header-logo"	
								src={require('./logo-text.svg')} alt="GPbook Logo" height="50" /></Link>
						</div>
						<div className="col-lg-9">
							{children}
						</div>
					</div>

			</div>			
		</header>
		);
	}
}

export default Header


// WEBPACK FOOTER //
// ./src/Components/Layout/Header.js